import React from 'react'
import { useTranslation } from 'react-i18next'
import CSS from 'csstype'
import { Button, Flex } from 'antd'

type FooterActionProps = {
  saveButtonDisabled?: boolean
  saveButtonEvent?: () => void
  cancelButtonEvent?: () => void
}

const FooterActions: React.FC<FooterActionProps> = ({
  saveButtonDisabled,
  saveButtonEvent,
  cancelButtonEvent,
}: FooterActionProps) => {
  const { t } = useTranslation(['digitalAsset', 'common', 'validation'])

  const buttonContainerStyle: CSS.Properties = {
    borderTop: '1px solid rgba(0, 0, 0, 0.08)',
    padding: '1em',
  }

  return (
    <Flex gap="middle" style={buttonContainerStyle}>
      <Button name={'submit-button'} disabled={saveButtonDisabled} onClick={saveButtonEvent}>
        {t('common:save')}
      </Button>
      <Button name={'submit-button'} onClick={cancelButtonEvent}>
        {t('common:dontSaveChanges')}
      </Button>
    </Flex>
  )
}

export default FooterActions
